import developmentApi from 'api/development.api'
import productionApi from 'api/production.api'
import stagingApi from 'api/staging.api'
import config from 'config'

const environments = {
  local: developmentApi,
  development: developmentApi,
  production: productionApi,
  staging: stagingApi,
}

export default environments[config.ENV] || productionApi
